import styled, { keyframes, css } from "styled-components";
import { ModalState } from "src/components/shared/Modal/ModalProvider";

const MODAL_Z_INDEX = 500;

const SET_INITIAL_POSITION = {
  bottom: 0,
  left: 0,
  right: 0,
};

export const MODAL_TRANSITION_TIME_MS = 200;

const fadeIn = keyframes`

  0% {opacity: 0; z-index: -1}
  1% {opacity:0; z-index: ${MODAL_Z_INDEX}}
  100% { opacity : 1; z-index: ${MODAL_Z_INDEX} }
`;

const fadeOut = keyframes`

  0% {opacity: 1; z-index: ${MODAL_Z_INDEX}}
  99% {opacity:0; z-index: ${MODAL_Z_INDEX}}
  100% { opacity : 0; z-index: -1 }
`;

const animationCss = css<ModalState>`
  animation-name: ${({ state }) =>
    state === "open" ? fadeIn : state === "closed" && fadeOut};
  animation-duration: ${MODAL_TRANSITION_TIME_MS}ms;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
`;

export const Container = styled.div.attrs({
  "data-cy": "modal-container",
})<ModalState>`
  position: fixed;
  ${SET_INITIAL_POSITION};
  display: flex;
  opacity: 0;
  z-index: -1;
  height: calc(100vh - 40px);

  ${animationCss}

  @media ${({ theme }) => theme.mq.md} {
    height: auto;
    top: 0;
  }
`;

export const Background = styled.div<ModalState>`
  position: fixed;
  ${SET_INITIAL_POSITION};
  background: rgba(0, 0, 0, 0.6);
  opacity: 0;
  z-index: -1;
  height: 100%;

  ${animationCss}
`;
